import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import RentalInputsContext from '@app/context/rental/RentalInputsContext';
import SearchForCard from './SearchForCard';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './VehicleResult.scss';


const NextArrow = ({ className, onClick }) => (
    <img
        src="https://cdn1.droom.in/photos/images/web/obv/images/right-angle.svg"
        alt="Next"
        onClick={onClick}
        className={`${className} custom-arrow`}
        style={{ width: 20, height: 20 }}
    />
);

const PrevArrow = ({ className, onClick }) => (
    <img
        src="https://cdn1.droom.in/photos/images/web/obv/images/left-angle.svg"
        alt="Previous"
        onClick={onClick}
        className={`${className} custom-arrow`}
        style={{ width: 20, height: 20 }}
    />
);

const SearchFor = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [viewAll, setViewAll] = useState(false);
    const [cardData, setCardData] = useState([]);

    const { rentalInputs } = React.useContext(RentalInputsContext);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const shuffleArray = (array) => {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        };
    
        fetch(`/rentals/get-rental-products`)
            .then(response =>
                response.json().catch(() => ({ data: [] }))
            )
            .then(data => {
                if (data?.code === 'success' && Array.isArray(data.data)) {
                    const shuffled = shuffleArray(data.data);
                    const formatted = shuffled.map(item => ({
                        image: item.photo,
                        title: item.product_name_mm,
                        location: rentalInputs?.start_city,
                        duration: '4 Hr / 40km'
                    }));
                    setCardData(formatted);
                }
            })
            .catch(error => {
                console.error('Error fetching rental products:', error);
            });
    }, []);

    useEffect(() => {
        if (cardData.length > 0) {
            const shuffled = [...cardData].sort(() => 0.5 - Math.random());
            setCardData(shuffled);
        }
    }, [rentalInputs?.product_title]);

    useEffect(() => {
        if (cardData.length > 0 && rentalInputs?.start_city) {
            setCardData(prev =>
                prev.map(card => ({
                    ...card,
                    location: rentalInputs.start_city
                }))
            );
        }
    }, [rentalInputs?.start_city]);

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false
                }
            }
        ]
    };

    const visibleCards = isMobile && !viewAll ? cardData.slice(0, 4) : cardData;

    return (
        <div className="">
            <h3 className="pb-3 charcol-grey">People also Search for</h3>
            {isMobile ? (
                <>
                    <div className="row">
                        {visibleCards.map((card, index) => (
                            <div className="col-6 mb-3" key={index}>
                                <SearchForCard {...card} />
                            </div>
                        ))}
                    </div>
                    {cardData.length > 4 && (
                        <div className="text-center ">
                            <button className="btn view-all-btn" onClick={() => setViewAll(!viewAll)}>
                                {viewAll ? 'View Less' : 'View All'}
                            </button>
                            <img
                                src="https://cdn1.droom.in/photos/images/web/obv/images/right-an.svg"
                                alt="icon"
                                width={12}
                                height={12}
                                style={{ transition: 'transform 0.3s' }}
                            />
                        </div>
                    )}
                </>
            ) : (
                <Slider {...settings}>
                    {cardData.map((card, index) => (
                        <div key={index} className="px-2">
                            <SearchForCard {...card} />
                        </div>
                    ))}
                </Slider>
            )}
        </div>
    );
};

export default SearchFor;
